import {ContentModalEntity} from '~/types/index';
import {Column} from './Column.client';
import {Copy} from './Copy.client';
import {Modal} from './Modal.client';
import {Table} from './Table.client';

export function ContentModal({
  data,
  open,
  setOpen,
}: {
  data: ContentModalEntity;
  open: boolean;
  setOpen: (open: boolean) => void;
}) {
  return (
    <Modal
      title={data.title}
      isOpen={open}
      onCloseModal={() => setOpen(false)}
      classNamePanel="w-[1272px] min-h-[833px] pl-5 md:pl-[131px] pr-5 py-5 md:pr-10 md:pt-10 md:pb-[131px]"
      classNameTitle="text-34/46 text-center md:text-left mt-[28px]"
    >
      <div className="md:pr-[53px] md:-ml-[38px] pt-1">
        {data.content &&
          data.content.map((content) => {
            if (!content || !content._type) {
              console.error(
                // @ts-ignore
                `Unknown component. type: ${content?._type} id: ${content?._id}`,
              );
              return null;
            }

            return (
              <div key={content.name}>
                {content._type === 'copy' && content?.copy && (
                  <Copy copy={content.copy} />
                )}
                {content._type === 'column' && <Column column={content} />}
                {content._type === 'tableInternal' && (
                  <div>
                    <div className="overflow-auto">
                      <Table table={content} />
                    </div>
                    {content.hideScrollText !== true && (
                      <div className="md:hidden text-16/26 text-gray-500 mt-1">
                        Scroll horizontally to see more.
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          })}
      </div>
    </Modal>
  );
}
